// removed by extract-text-webpack-plugin
module.exports = {"buttonIcon":"buttons__buttonIcon___1yaNv"};


//////////////////
// WEBPACK FOOTER
// ./components/Toolbar/buttons.scss
// module id = ./components/Toolbar/buttons.scss
// module chunks = 5